<template>
    <ComparisonCard
        v-if="values[0] + values[1] > 0"
        :values="values"
        :labels="labels"
        :quotes="quotes"
        :comparisonLabels="['Made the course easy', 'Made the course hard']"
    >
        <template v-slot:header-title-text>
            <h3 class="soft-text">{{ sentenceLabel }}</h3>
        </template>
        <template v-slot:header-title-text-expanded>
            <p class="soft-text">Course difficulty</p>
            <h4 class="left-text">
                <strong>{{ sentenceLabel }}</strong>
            </h4>
        </template>

        <template v-slot:header-title-text-mobile>
            <h4 class="soft-text">{{ sentenceLabel }}</h4>
            <p class="primary-text subheader">This course is voted {{ lowercaseLabel }}</p>
        </template>
        <template v-slot:header-title-text-expanded-mobile>
            <h4 class="soft-text">
                <strong class="primary-text">{{ capitalizedLabel }}</strong>
            </h4>
        </template>
    </ComparisonCard>
</template>

<script>
import ComparisonCard from "@/components/cards/MetricComparisonCard";

export default {
    name: "DifficultyCard",
    props: {
        reviews: Array,
    },
    components: {
        ComparisonCard,
    },
    computed: {
        firstName() {
            return this.name.split(" ")[0];
        },
        capitalizedLabel() {
            return this.values[0] - this.values[1] < 0 ? "Hard Course" : "Easy Course";
        },
        sentenceLabel() {
            return this.values[0] - this.values[1] < 0 ? "Hard course" : "Easy course";
        },
        lowercaseLabel() {
            return this.values[0] - this.values[1] < 0 ? "hard" : "easy";
        },
        values() {
            let easy = 0,
                hard = 0;
            this.reviews.forEach((r) => {
                let d = r.rating.difficulty;
                if (d < 3) easy += 1;
                if (d > 3) hard += 1;
            });
            return [easy, hard];
        },
        quotes() {
            let easyReviews = [],
                hardReviews = [];
            this.reviews.forEach((r) => {
                let d = r.rating.difficulty;
                if (r.difficulty !== undefined && r.difficulty.comment !== undefined && r.difficulty.comment !== null) {
                    let dtext = r.difficulty.comment;
                    if (d < 3) {
                        easyReviews.push(dtext);
                    } else if (d > 3) {
                        hardReviews.push(dtext);
                    }
                }
            });
            return easyReviews.length > 0 || hardReviews.length > 0 ? [easyReviews, hardReviews] : null;
        },
    },
    created() {
        this.$on("expand", () => {
            this.$parent.$emit("expand");
        });
    },
    data() {
        return { labels: ["Easy", "Hard"] };
    },
};
</script>
